import { __assign } from "tslib";
export var seoApiRelativePath = "/helpcenter/seo";
export var createSeoApi = function (baseUrl, http) {
    var apiUrl = "" + baseUrl + seoApiRelativePath;
    return {
        getPageSeo: function (dto) {
            return http.get(apiUrl + "/" + dto.type + "/" + dto.locale + (dto.brandId ? "?brandId=" + dto.brandId : ''));
        },
        updatePageSeo: function (dto) {
            return http.post(apiUrl + "/" + dto.type + "/" + dto.locale, dto.brandId ? __assign(__assign({}, dto.data), { brandId: dto.brandId }) : dto.data);
        }
    };
};
//# sourceMappingURL=index.js.map